import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0ProviderWithNavigate } from './components/Auth0ProviderWithNavigate';
import { AnalyticsPackageProvider } from './context/AnalyticsPackageContext';
import { UserProvider } from './context/UserContext';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AnalyticsPackageProvider>
        <Auth0ProviderWithNavigate>
          <UserProvider>
            <App />
          </UserProvider>
        </Auth0ProviderWithNavigate>
      </AnalyticsPackageProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
